import { VEHICLE_MAX_ROUTE_DURATION_MINUTES } from './optimizeRoute.js';

export function getWorkingTimeMinutes(
  startTime: string | Date | null | undefined,
  endTime: string | Date | null | undefined,
  capAtMaxRouteDuration = true,
): number | null {
  if (!startTime || !endTime) return null;
  const startMs = new Date(startTime).getTime();
  const endMs = new Date(endTime).getTime();
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) return null;
  const minutes = Math.round((endMs - startMs) / (1000 * 60));
  return capAtMaxRouteDuration ? Math.min(minutes, VEHICLE_MAX_ROUTE_DURATION_MINUTES) : minutes;
}
